import { render, staticRenderFns } from "./AddDistributorModal.vue?vue&type=template&id=43053595"
import script from "./AddDistributorModal.vue?vue&type=script&lang=js"
export * from "./AddDistributorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports